'use client';

import { Typography } from 'src/components/PulseUI';
import { handleNumericValue } from 'src/utils/handleNumericValue/handleNumericValue';
import { useProspectSearch } from 'src/context/prospects';
import { useTable } from 'src/context/table';

const TrendVolumeCell = ({ row, field }) => {
  // remove the option_ prefix from the field
  field = field.replace('option_', '');
  const { currentSearchIds } = useTable();

  const { prospectVolumeType } = useProspectSearch();

  if (currentSearchIds.length > 1) return;
  const currentSearchId = currentSearchIds[0];

  // Get the correct trends based on available data
  const correctTrends =
    row?.trends?.[currentSearchId]?.[Number(field)] ||
    row?.trends?.[prospectVolumeType]?.[currentSearchId]?.[Number(field)] ||
    row?.volume_trends?.[prospectVolumeType]?.[currentSearchId]?.[
      Number(field)
    ] ||
    row?.volume_trends?.[currentSearchId]?.[Number(field)];

  return (
    <Typography variant="body2" bold>
      {handleNumericValue(correctTrends) || 0}
    </Typography>
  );
};

export default TrendVolumeCell;
